import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid-pro'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Addchart, FileDownload, Settings } from '@mui/icons-material'
import ExportFormatField from './ExportFomatField'

export function useStudySelectDGCols(statusFilter: string) {
  const navigate = useNavigate()
  const [selectedID, setSelectedID] = useState<number | undefined>(undefined)
  const [anchorEl, setAnchorEl] = useState<any>(null)
  const cols: GridColDef[] = [
    {
      field: 'StudyID',
      headerName: 'Study ID',
      width: 120,
    },
    {
      field: 'StudyName',
      headerName: 'Study Name',
      flex: 1,
    },
    {
      type: 'actions',
      field: 'config',
      headerName: 'Configure',
      width: 90,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<Settings sx={{ fontSize: '1.6rem' }} />}
          onClick={() => navigate(`/stuart/study/${params.id}/configure`)}
          label="Configure"
        />,
      ],
    },
    {
      type: 'actions',
      field: 'entry',
      headerName: 'Data',
      width: 90,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<Addchart sx={{ fontSize: '1.6rem' }} />}
          onClick={() => navigate(`/stuart/study/${params.id}/entry`)}
          label="Data Entry"
          disabled={statusFilter !== 'ACT'}
        />,
      ],
    },
    {
      type: 'actions',
      field: 'export',
      headerName: 'Export All',
      width: 90,
      getActions: (params: GridRowParams) => [
        <>
          <ExportFormatField
            selectedId={selectedID ? selectedID.toString() : ''}
            rowId={params?.id.toString()}
            animals={[-1]}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            source={'Study'}
          />
          <GridActionsCellItem
            icon={<FileDownload sx={{ fontSize: '1.6rem' }} />}
            onClick={(e) => {
              setSelectedID(params?.id as number)
              setAnchorEl(e.currentTarget)
            }}
            label="Export"
            disabled={statusFilter === 'PEN' || params.id === 1}
          />
        </>,
      ],
    },
  ]
  return cols
}
